import { ReactElement, ReactNode, useEffect } from 'react';
import { ScrollView } from 'react-native-gesture-handler';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { Heading } from '@/common/components/Heading/Heading';
import { Stack } from '@/common/components/Stack/Stack';
import { cn } from '@/common/theme/tv.config';
import { styles } from './ModalLearningStep.styles';

export type TModalLearningStepProps = {
  title: ReactNode;
  description?: ReactNode;
  asset?: ReactElement<object>;
  assetContainerSize?: 'md' | 'lg';
  onShow?: () => void;
};

export function ModalLearningStep({
  title,
  description,
  asset,
  assetContainerSize,
  onShow,
}: TModalLearningStepProps) {
  useEffect(() => {
    if (onShow) {
      onShow();
    }
  }, [onShow]);

  return (
    <Stack align="center" className={styles.root}>
      <Stack
        align="center"
        justify="center"
        className={cn(
          styles.column(),
          styles.asset({ size: assetContainerSize })
        )}
      >
        {asset ? (
          <asset.type {...asset.props} width={300} height={300} />
        ) : null}
      </Stack>
      <Stack className={cn(styles.column({ content: true }))}>
        <ScrollView
          className={styles.scrollView}
          contentContainerClassName={styles.scrollViewContent}
        >
          <Stack className={styles.scrollColumn}>
            <Heading level={3}>{title}</Heading>
            {typeof description === 'string' ? (
              <BodyText>{description}</BodyText>
            ) : (
              description
            )}
          </Stack>
        </ScrollView>
      </Stack>
    </Stack>
  );
}
